"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitions = exports.types = exports.positions = void 0;
exports.positions = {
    TOP_LEFT: 'top left',
    TOP_CENTER: 'top center',
    TOP_RIGHT: 'top right',
    MIDDLE_LEFT: 'middle left',
    MIDDLE: 'middle',
    MIDDLE_RIGHT: 'middle right',
    BOTTOM_LEFT: 'bottom left',
    BOTTOM_CENTER: 'bottom center',
    BOTTOM_RIGHT: 'bottom right',
};
exports.types = {
    INFO: 'info',
    SUCCESS: 'success',
    ERROR: 'error',
    PROGRESS_INDICATOR: 'progress_indicator',
};
exports.transitions = {
    FADE: 'fade',
    SCALE: 'scale',
    SLIDE_RIGHT: 'slide_right',
    SLIDE_LEFT: 'slide_left',
    SLIDE_TOP: 'slide_top',
    SLIDE_BOTTOM: 'slide_bottom',
};
